<dropdown
  [label]=""
  [hideEmptyOption]="false"
  [availableValues]="effectiveAvailableValues"
  [selectedValue]="this.effectiveSelectedValue"
  (selectedValueChange)="setSelectedValue($event)"
  [disabled]="effectiveDisabled"
  class="sc-input"
></dropdown>
